import { DesignPageProvider } from "../../context/DesignPageContext";
import ServicePageLayout from "./ServicePageLayout";

export default function Design() {
  return (
    <DesignPageProvider>
      <ServicePageLayout />
    </DesignPageProvider>
  );
}
